/**
 * Зависимости
 */
import './polyfills';
import '../../sections/first-screen';
import '../../sections/location';
import '../../sections/documents';
import '../../sections/progress';
import '../../sections/action-section';
import '../../sections/purchase';
import '../../sections/contacts';
import '../../sections/flats';
import '../../sections/mortgage';
import {
    fixPopupHeader,
    initCallbackForm,
    initCallbackPopups,
    initHeader,
    initMobileMenu,
    initPromoPopups,
    lazyLoadElements
} from './common';
// import CookiesNotice from '../../components/cookies-notice';
import AlertOldBrowser from 'components/alert-old-browser';
import Html2Pdf from 'components/html2pdf';
import Observer from 'common/scripts/observer';
import parametric from 'components/parametric';
import ScrollBy from 'components/scrollBy';
import Slider from 'components/slider';
const observer = new Observer();

// Поведение шапки
const headerWrap = document.querySelector('.j-header');

if (headerWrap) {
    initHeader(headerWrap);
}

// Поведение меню
const burgerMenuSelector = document.querySelector('.j-burger-menu');

if (burgerMenuSelector) {
    initMobileMenu(burgerMenuSelector, headerWrap);
}

// Попапы обратной связи и инциализация формы
const popupLinks = Array.from(document.querySelectorAll('.j-popup-callback-call'));

if (popupLinks.length) {
    initCallbackPopups(popupLinks);
    initCallbackForm();

    // Отправка событий в наш GTM (GTM-KLDKSDN) c кнопки
    const hdrCallbackLinks = popupLinks.filter((item) => {
        return item.classList.contains('j-popup-callback-gtm');
    });
    const flatRequestLinks = popupLinks.filter((item) => {
        return item.classList.contains('j-popup-flat-gtm');
    });

    if (hdrCallbackLinks.length) {
        hdrCallbackLinks.forEach((item) => {
            item.addEventListener('click', () => {
                window.dataLayer = window.dataLayer || [];
                const title = document.title;

                window.dataLayer.push({
                    'event': 'gaEvent',
                    'gaCategory': 'form',
                    'gaAction': 'open',
                    'gaLabel': 'callback-header'
                });
                window.dataLayer.push({
                    'event': 'Pageview',
                    'pagePath': '/#form-open-callback-header',
                    'pageTitle': '{title} - Заказать звонок в шапке - показ формы'
                });
            });
        });
    }

    if (flatRequestLinks.length) {
        flatRequestLinks.forEach((item) => {
            item.addEventListener('click', () => {
                window.dataLayer = window.dataLayer || [];

                const title = document.title;
                window.dataLayer.push({
                    'event':'gaEvent',
                    'gaCategory':'form',
                    'gaAction':'open',
                    'gaLabel':'flatRequest'
                });
                window.dataLayer.push({
                    'event': 'Pageview',
                    'pagePath': '/#form-open-flatRequest',
                    'pageTitle': '{title} - Заявка на квартиру - показ формы'
                });
            });
        });
    }
}

// Промо-попап
const popupPromoLinks = Array.from(document.querySelectorAll('.j-popup-promo'));

if (popupPromoLinks.length) {
    initPromoPopups(popupPromoLinks);

    popupPromoLinks.forEach((item) => {
        if (!sessionStorage.getItem('promo') && item.getAttribute('data-href') === '#promo') {
            setTimeout(() => {
                item.click();
                sessionStorage.setItem('promo', 'shown');
            }, 1000);
        }
    });
}

// При открытии попапа сдвигаем шапку на ширину сколл-бара.
fixPopupHeader(headerWrap);

// Cкролл по якорям
const anchors = Array.from(document.querySelectorAll('.j-anchor'));

if (anchors.length) {
    const scrollBy = new ScrollBy();

    scrollBy.init({
        takeElements: [headerWrap],
        anchors
    });

    observer.subscribe('anchorChangeSection', (id) => {
        anchors.forEach((item) => {
            item.classList.remove('is-active');

            const href = item.getAttribute('href');

            if (href === id) {
                item.classList.add('is-active');
            }
        });
    });
}

// Большой слайдер
const sliderWrap = Array.from(document.querySelectorAll('.j-slider'));

if (sliderWrap.length) {
    sliderWrap.forEach((item) => {
        const slider = new Slider();

        slider.init({
            slider       : item,
            dots         : false,
            thumbnails   : false,
            arrow        : true,
            counter      : true,
            arrowPosition: 'caption',
            caption      : true,
            modify       : 'big_slide',
            infinityLoop : true,
            lazy         : true
        });
    });
}

// Подключение мелких галлерей
const slidersMini = Array.from(document.querySelectorAll('.j-slider-mini'));

if (slidersMini.length) {
    slidersMini.forEach((item) => {
        const sliderMini = new Slider();

        sliderMini.init({
            slider       : item,
            dots         : false,
            thumbnails   : false,
            arrow        : true,
            counter      : true,
            arrowPosition: 'caption',
            modify       : 'mini_slide',
            infinityLoop : true,
            lazy         : true
        });
    });
}

// Подключение параметрического поиска
const id = '#parametric';
const parametricWrap = document.querySelector(id);

if (parametricWrap) {
    // тип выборщика (1 - квартиры / 2 - коммерция)
    const parametricType = Number(parametricWrap.dataset.estateType) || 1;

    parametric({
        id,
        // количество квартир на 1 странице
        showItemPage  : 6,
        // брейкпоинт для смены вида карточки/таблицa
        viewBreakpoint: 960,
        estateType    : parametricType
    });
}

// Подключение генератора pdf
const pdfLinks = Array.from(document.querySelectorAll('.j-html2pdf'));

if (pdfLinks.length) {
    const html2pdf = new Html2Pdf();

    html2pdf.init({
        targets    : pdfLinks,
        autoload   : true,
        orientation: 'portrait',
        quality    : 5,
        pageBreak  : '.pdf__page-break'
    });
}

// Плашка старых браузеров
const alertOldBrowser = new AlertOldBrowser();

alertOldBrowser.init([{
    name   : 'chrome',
    version: 57
}, {
    name   : 'firefox',
    version: 53
}, {
    name   : 'opera',
    version: 44
}, {
    name   : 'ie',
    version: 12
}, {
    name   : 'safari',
    version: 11
}, {
    name   : 'edge',
    version: 16
}]);

const lazyElements = Array.from(document.querySelectorAll('[loading=lazy]'));

if (lazyElements.length) {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            lazyLoadElements(lazyElements);
        });
    } else {
        lazyLoadElements(lazyElements);
    }
}

observer.subscribe('lazyLoad:refresh', (container) => {
    const secLazyElements = Array.from(container.querySelectorAll('[loading=lazy]'));

    lazyLoadElements(secLazyElements);
});

// Подключение GTM из скриптов
const scriptHead = document.createElement('script');

scriptHead.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-KLDKSDN');`;

const scrtiptBody = document.createElement('noscript');

scrtiptBody.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-KLDKSDN"
height="0" width="0" style="display:none;visibility:hidden"></iframe>`;

const head = document.getElementsByTagName('head')[0];
const body = document.getElementsByTagName('body')[0];

head.insertBefore(scriptHead, head.lastChild);
body.insertBefore(scrtiptBody, body.lastChild);

// Уведомление об использовании куки.
// const cookiesWrapper = document.querySelector('.j-cookies-notice');
//
// if (cookiesWrapper) {
//     const cookies = new CookiesNotice();
//
//     cookies.init(cookiesWrapper);
// }

